// extracted by mini-css-extract-plugin
export default {"modal-scope":"LocalizationModal_modal-scope__0-Cel","save-localization-btn":"LocalizationModal_save-localization-btn__de1jR"};